import { Link } from 'react-router-dom'
import { ArrowUpRight, ExternalLink } from 'lucide-react'
import type { BlogPost } from '@/types'
import { Badge } from '@/components/ui/badge'
import { formatDate } from '@/lib/utils'

export function BlogCard({ post }: { post: BlogPost }) {
  const isExternal = Boolean(post.externalUrl)
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group flex flex-col gap-2 border-b border-border/60 py-6 first:pt-0"
    >
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        <span>{formatDate(post.date)}</span>
        <span>·</span>
        <span>{post.category}</span>
        {post.readTime > 0 && (
          <>
            <span>·</span>
            <span>{post.readTime} min read</span>
          </>
        )}
      </div>
      <h3 className="flex items-center gap-1.5 text-lg font-semibold leading-snug group-hover:text-primary">
        {post.title}
        {isExternal ? (
          <ExternalLink className="h-4 w-4 shrink-0 text-muted-foreground" />
        ) : (
          <ArrowUpRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        )}
      </h3>
      <p className="line-clamp-2 text-sm text-muted-foreground">
        {post.excerpt}
      </p>
      <div className="flex flex-wrap gap-1.5 pt-1">
        {post.tags.slice(0, 4).map((tag) => (
          <Badge key={tag} variant="outline" className="font-normal">
            {tag}
          </Badge>
        ))}
      </div>
    </Link>
  )
}
